import { makeObservable, observable, action } from 'mobx';

export const STEP_COUNT = 7;

class RequestFormStepperStore {
  currentStep: number = 0;

  constructor() {
    makeObservable(this, {
      currentStep: observable,
      setStep: action,
      next: action,
      prev: action,
      reset: action
    });
  }

  setStep = (step: number) => {
    if (step >= 0 && step < STEP_COUNT) {
      this.currentStep = step;
    }
  };

  next = () => {
    if (this.currentStep < STEP_COUNT - 1) this.currentStep++;
  };

  prev = () => {
    if (this.currentStep > 0) this.currentStep--;
  };

  reset = () => {
    this.currentStep = 0;
  };
}

const singleton = new RequestFormStepperStore();
export default singleton;
